module.exports = __webpack_public_path__ + "2026310:ef9a7edf554eddff21f3/img/Till-This-Day-Tile_no-spot.44aac0a.png";